/* ARTMiE Category C — ostrovy radov: parallax pri scrolle, náklon fotky za myšou, postupné zobrazenie. */
(function () {
  // video: klik načíta YouTube prehrávač (youtube-nocookie) až na požiadanie
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.acc-video__play[data-yt]');
    if (!b || b.dataset.on) return;
    b.dataset.on = '1';
    var f = document.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.dataset.yt) + '?autoplay=1&rel=0';
    f.title = b.getAttribute('aria-label') || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    var w = document.createElement('div');
    w.className = 'acc-video__play';
    w.appendChild(f);
    b.replaceWith(w);
  });

  // pás výhod: kanonické správanie LP perks (SPEED 0.3, ťahanie myšou/prstom)
  function perks() {
    document.querySelectorAll('.acc-perks').forEach(function (box) {
      var track = box.querySelector('.acc-perks-track');
      if (!track || box.dataset.perksDrag) return;
      box.dataset.perksDrag = '1';
      var half = 0, pos = 0;
      function measure() { var w = track.scrollWidth / 2; if (w > 0) half = w; }
      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      [300, 900, 2000].forEach(function (ms) { setTimeout(measure, ms); });
      var SPEED = 0.3, paused = false, dragging = false, startX = 0, startScroll = 0, resumeT = null;
      function tick() {
        if (!half) measure();
        if (!paused && !dragging && half && box.offsetParent) { pos += SPEED; if (pos >= half) pos -= half; box.scrollLeft = pos; }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      box.addEventListener('mouseenter', function () { paused = true; });
      box.addEventListener('mouseleave', function () { if (!dragging) paused = false; });
      box.addEventListener('mousedown', function (e) { dragging = true; paused = true; startX = e.pageX; startScroll = box.scrollLeft; box.classList.add('is-grabbing'); e.preventDefault(); });
      window.addEventListener('mousemove', function (e) { if (!dragging) return; var x = startScroll - (e.pageX - startX); if (half) { if (x >= half) x -= half; else if (x < 0) x += half; } box.scrollLeft = x; });
      window.addEventListener('mouseup', function () { if (!dragging) return; dragging = false; box.classList.remove('is-grabbing'); pos = box.scrollLeft; paused = box.matches(':hover'); });
      box.addEventListener('touchstart', function () { paused = true; if (resumeT) clearTimeout(resumeT); }, { passive: true });
      box.addEventListener('touchend', function () { resumeT = setTimeout(function () { pos = box.scrollLeft; paused = false; }, 1500); }, { passive: true });
    });
  }

  function init() {
    perks();
    var wraps = document.querySelectorAll('.acc-isl-wrap');
    if (!wraps.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isl = [];
    wraps.forEach(function (w) {
      w.closest('.acc').classList.add('acc-js');
      w.querySelectorAll('.acc-isl').forEach(function (el) { isl.push(el); });
    });

    var raf = 0;
    function tick() {
      raf = 0;
      var vh = window.innerHeight;
      isl.forEach(function (el) {
        var b = el.getBoundingClientRect();
        if (b.top < vh * 0.85) el.classList.add('in');
        if (reduce || b.bottom < -200 || b.top > vh + 200) return;
        var p = ((b.top + b.height / 2) - vh / 2) / (vh / 2 + b.height / 2);
        p = Math.max(-1, Math.min(1, p));
        el.style.setProperty('--p', p.toFixed(3));
      });
    }
    function on() { if (!raf) raf = requestAnimationFrame(tick); }
    tick();
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('resize', on);

    if (reduce || !(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    isl.forEach(function (el) {
      var stage = el.querySelector('.acc-isl-stage');
      if (!stage) return;
      stage.addEventListener('mousemove', function (e) {
        var b = stage.getBoundingClientRect();
        stage.style.setProperty('--mx', ((e.clientX - b.left) / b.width - 0.5).toFixed(3));
        stage.style.setProperty('--my', ((e.clientY - b.top) / b.height - 0.5).toFixed(3));
        stage.classList.add('hot');
      });
      stage.addEventListener('mouseleave', function () {
        stage.style.setProperty('--mx', 0);
        stage.style.setProperty('--my', 0);
        stage.classList.remove('hot');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
